import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const queryCache = new Map()

const getQuery = (apiBaseUrl) => {
  if (!queryCache.has(apiBaseUrl)) {
    queryCache.set(
      apiBaseUrl,
      fetchBaseQuery({
        baseUrl: apiBaseUrl || "/",
        credentials: apiBaseUrl ? "omit" : "include",
        prepareHeaders: (headers) => {
          if (!apiBaseUrl) {
            const csrfToken = document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute("content")
            if (csrfToken) headers.set("X-CSRF-Token", csrfToken)
          }
          return headers
        },
      })
    )
  }
  return queryCache.get(apiBaseUrl)
}

const rawBaseQuery = (args, api, extraOptions) => {
  const { apiBaseUrl } = api.extra?.embedConfig ?? {}
  return getQuery(apiBaseUrl)(args, api, extraOptions)
}

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: rawBaseQuery,
  endpoints: () => ({}),
  tagTypes: ["BundleColumns", "ColumnTemplates", "TourShareTemplate", "SavedToursBrandingSettings"],
  refetchOnFocus: false,
})

export default baseApi
